(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.video-tab');
    const mainVideo = document.getElementById('mainVideo');
    const overlay = document.querySelector('.video-overlay');
    const titleElement = document.querySelector('.video-header-title');
    const descElement = document.querySelector('.video-header-desc');

    const videoData = [
      {
        url: 'https://vantrue-app.vantruecam.com/video/p2/Night%20Driving.mp4',
        title: ' Night Driving',
        desc: '',
      },
      {
        url: 'https://vantrue-app.vantruecam.com/video/p2/Pedestrian%20Alerts.mp4',
        title: ' Pedestrian Alerts',
        desc: '',
      },
      {
        url: 'https://vantrue-app.vantruecam.com/video/p2/Wildlife%20Alerts.mp4',
        title: ' Wildlife Alerts',
        desc: '',
      },
      {
        url: 'https://vantrue-app.vantruecam.com/video/p2/Obstructed%20Visibility.mp4',
        title: ' Obstructed Visibility',
        desc: '',
      },
      {
        url: 'https://vantrue-app.vantruecam.com/video/p2/See%20Through%20Wildfire%20Smoke.mp4',
        title: ' See Through Wildfire Smoke',
        desc: '',
      },
    ];
    if (videoData[0]) {
      titleElement.textContent = videoData[0].title;
      descElement.textContent = videoData[0].desc;
    }

    mainVideo
      .play()
      .then(() => {
        overlay.style.opacity = '0';
      })
      .catch((err) => {
        console.log('Auto-play prevented, will play on user interaction');
      });

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function () {
        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        if (videoData[index]) {
          mainVideo.src = videoData[index].url;
          titleElement.textContent = videoData[index].title;
          descElement.textContent = videoData[index].desc;

          mainVideo.load();
          mainVideo.play();
        }
      });
    });

    mainVideo.addEventListener('play', function () {
      overlay.style.opacity = '0';
    });

    mainVideo.addEventListener('pause', function () {
      overlay.style.opacity = '1';
    });
  });

  function toggleVideo() {
    const mainVideo = document.getElementById('mainVideo');
    const overlay = document.querySelector('.video-overlay');

    if (mainVideo.paused) {
      mainVideo.play();
      overlay.style.opacity = '0';
    } else {
      mainVideo.pause();
      overlay.style.opacity = '1';
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-card-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* 初始化单个 video-card-section 实例
       所有选择器都限定在本 section 根节点内，页面同时存在其他视频模块时也不会互相抢绑定 */
    function initVideoCard(root) {
      if (!root || root.dataset.vcInit === '1') return;

      var mainVideo = root.querySelector('.video-player-container video');
      if (!mainVideo) return;

      root.dataset.vcInit = '1';

      var tabs = root.querySelectorAll('.video-tab');
      var overlay = root.querySelector('.video-overlay');
      var captionTitle = root.querySelector('.video-caption-title');
      var captionDesc = root.querySelector('.video-caption-desc');
      var loader = root.querySelector('.video-loader');
      var loaderTimer = null;

      /* 顶部标题 / 描述：切换选项卡时替换为该 Video Item 的文案；
         item 文案留空时回退到 section 级的默认文案 */
      var headerTitle = root.querySelector('.video-header-title');
      var headerDesc = root.querySelector('.video-header-desc');
      var headerTitleDefault = headerTitle ? headerTitle.textContent : '';
      var headerDescDefault = headerDesc ? headerDesc.textContent : '';

      /* Loading 显示 / 隐藏：延时 200ms 显示，避免已缓存视频出现闪烁 */
      function showLoader() {
        if (loaderTimer) return;
        loaderTimer = setTimeout(function () {
          loaderTimer = null;
          if (loader) loader.classList.add('is-loading');
        }, 200);
      }

      function hideLoader() {
        if (loaderTimer) {
          clearTimeout(loaderTimer);
          loaderTimer = null;
        }
        if (loader) loader.classList.remove('is-loading');
      }

      ['loadstart', 'waiting', 'stalled'].forEach(function (ev) {
        mainVideo.addEventListener(ev, showLoader);
      });
      ['playing', 'canplay', 'canplaythrough', 'loadeddata', 'error', 'pause', 'ended'].forEach(function (ev) {
        mainVideo.addEventListener(ev, hideLoader);
      });

      /* 首屏兜底：脚本执行时可能已错过 loadstart，首个视频若仍未就绪则显示 loading */
      if (mainVideo.readyState < 3) showLoader();

      function playVideo() {
        var p = mainVideo.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function toggleVideo() {
        if (mainVideo.paused) {
          playVideo();
          if (overlay) overlay.style.opacity = '0';
        } else {
          mainVideo.pause();
          if (overlay) overlay.style.opacity = '1';
        }
      }

      if (overlay) overlay.addEventListener('click', toggleVideo);

      /* 把选项卡对应的 Video Title / Video Description 同步到顶部标题、描述和视频叠加文案；
         item 文案留空时回退到 section 级的默认文案 */
      function applyTabText(tab) {
        var tabTitle = tab.getAttribute('data-video-title') || '';
        var tabDesc = tab.getAttribute('data-video-desc') || '';
        if (captionTitle) captionTitle.textContent = tabTitle;
        if (captionDesc) captionDesc.textContent = tabDesc;
        if (headerTitle) headerTitle.textContent = tabTitle || headerTitleDefault;
        if (headerDesc) headerDesc.textContent = tabDesc || headerDescDefault;
      }

      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          Array.prototype.forEach.call(tabs, function (t) {
            t.classList.remove('active');
          });
          tab.classList.add('active');

          var url = tab.getAttribute('data-video-url');
          if (!url) {
            console.warn('[video-card-section] 该选项卡未配置 Video URL，请在后台为该 Video Item 填写视频地址');
            return;
          }

          mainVideo.src = url;
          applyTabText(tab);

          mainVideo.load();
          playVideo();
        });
      });

      mainVideo.addEventListener('play', function () {
        if (overlay) overlay.style.opacity = '0';
      });

      mainVideo.addEventListener('pause', function () {
        if (overlay) overlay.style.opacity = '1';
      });

      /* 首屏与当前激活的选项卡保持一致：直接显示第 1 个 item 的 Video Title / Video Description */
      var activeTab = root.querySelector('.video-tab.active') || tabs[0];
      if (activeTab) applyTabText(activeTab);

      playVideo();
    }

    function initAll() {
      var roots = document.querySelectorAll('.custom-video-section3[data-section-id]');
      Array.prototype.forEach.call(roots, initVideoCard);
    }

    /* {% javascript %} 可能在 DOM 解析完成后才执行，因此不能只依赖 DOMContentLoaded */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
